'use client';

import { Button } from '@ahafood/ui/components/button';
import { assetPrefix } from '@ahm/api-wrappers-core';
import Image from 'next/image';
import { trackEvent } from '@/lib/event-tracking';
import { useAuthStore } from '@/store';

interface AIAssistantMessageProps {
  onAskAI: () => void;
}

export function AIAssistantMessage({ onAskAI }: AIAssistantMessageProps) {
  const { user } = useAuthStore();
  const handleAskAIClick = () => {
    trackEvent('order_event', {
      button_name: 'click_ai_button',
      button_location: 'store_detail',
      user_id: user?.cunstomerId,
    });
    onAskAI();
  };

  return (
    <div className="p-0 rounded-lg">
      <div className="flex items-center justify-between">
        {/* AI Mascot and Message */}
        <div className="flex items-center gap-0 w-full">
          <div className="relative">
            <Image
              src={`${assetPrefix}/static/images/chatbot-detail.webp`}
              alt="Amori AI Assistant"
              width={64}
              height={64}
              className="rounded-full"
            />
          </div>
          <div className="flex items-center gap-2 bg-gradient-to-r from-primary-10 to to-blue-10 w-full pr-4 py-2 pl-8 rounded-lg ml-[-30px] shadow-4 justify-between">
            <i className="text-neutral-50 text-sm font-medium">
              <span className="flex items-center">
                <Image
                  src={`${assetPrefix}/static/images/new.png`}
                  alt="New"
                  width={24}
                  height={24}
                  className="rounded-full mr-1 rotate-12"
                />
                Đặt trực tiếp trên{' '}
                <span className="ml-1 font-semibold bg-gradient-to-r from-blue-40 to-primary-50 inline-block text-transparent bg-clip-text pr-0.5">
                  Ahafood
                </span>
              </span>
              <span className="font-semibold bg-gradient-to-r from-blue-40 to-primary-50 inline-block text-transparent bg-clip-text pr-0.5">
                Trợ lí Amori
              </span>{' '}
              mách món cho bạn...😉
            </i>
            <Button
              className="px-4 py-2 text-sm font-semibold rounded-lg bg-white hover:bg-neutral-10"
              onClick={handleAskAIClick}
            >
              <div className="bg-gradient-to-r from-blue-50 to-primary-50 inline-block text-transparent bg-clip-text">
                Hỏi AI
              </div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
